module.exports = __webpack_public_path__ + "media/sales_marketing_strategies/bidding_photo_01-6751dacc.webp";